/* TODO: t() */
import { StyleSheet } from 'react-native';

// TODO: Remove these when done refactoring settings.
const settingsStyles = StyleSheet.create({
  radioGroup: {
    paddingVertical: 5,
  },
  radioItem: {
    marginRight: 30,
    marginVertical: 10,
  },
});

export default settingsStyles;
